import { Component, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BracketItemComponent } from './components/bracket-item/bracket-item.component';
import { BracketWrapperComponent } from './components/bracket-wrapper/bracket-wrapper.component';
import { DuelSeriesViewComponent } from './components/duel-series-view/duel-series-view.component';
import { FullWidthContainerComponent } from './components/full-width-container/full-width-container.component';
import { GroupGameComponent } from './components/group-game/group-game.component';
import { PlayersComponent } from './components/players/players.component';
import { RoundItemComponent } from './components/round-item/round-item.component';
import { VideoLayerComponent } from './components/video-layer/video-layer.component';
import {PlayersPageComponent} from "./components/playersPage/players-page/players-page.component";
import { AuthorizationComponent } from './components/authorization/authorization.component';
import {PrivateOfficeComponent} from "./components/private-office/private-office.component";
import {
  SetUpGridPlayersManagmentButtonComponent
} from "./components/set-up-grid-players-managment-button/set-up-grid-players-managment-button.component";
import { TournamentStatusComponent } from './components/tournament-status/tournament-status.component';
import {RatingsPageComponent} from "./components/ratings-page/ratings-page.component";
import { TableAddComponent } from './components/tables/table-add/table-add.component';
import { TableDeleteActivateComponent } from './components/tables/table-delete-activate/table-delete-activate.component';
import {SingleRatingPageComponent} from "./components/single-rating-page/single-rating-page.component";
import {RatingEditorComponent} from "./components/rating-editor/rating-editor.component";

@Component({
  selector: 'tournament-master',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Tournament Master';

  constructor(
    injector: Injector,
  ) {
    const projectCustomElements: any = {
      'group-game': GroupGameComponent,
      'duel-series-view': DuelSeriesViewComponent,
      'bracket-item': BracketItemComponent,
      'players-list': PlayersComponent,
      'full-width-container': FullWidthContainerComponent,
      'bracket-wrapper': BracketWrapperComponent,
      'round-item': RoundItemComponent,
      'video-layer': VideoLayerComponent,
      'players-page': PlayersPageComponent,
      'authorization-component': AuthorizationComponent,
      'private-office': PrivateOfficeComponent,
      'set-up-grid-players-management-button': SetUpGridPlayersManagmentButtonComponent,
      'tournament-status': TournamentStatusComponent,
      'ratings-page': RatingsPageComponent,
      'table-add': TableAddComponent,
      'table-delete-activate': TableDeleteActivateComponent,
      'single-rating-page': SingleRatingPageComponent,
      'rating-editor-page': RatingEditorComponent,
    };

    for (let elementName in projectCustomElements) {
      if (!projectCustomElements.hasOwnProperty(elementName)) {
        continue;
      }

      const component = projectCustomElements[elementName];

      const element = createCustomElement(component, { injector });
      customElements.define(elementName, element);
    }
  }
}
